const ZERNIO_CONNECT_WINDOW = 'mercately-zernio-connect';

const isZernioConnectWindow = () => (
  typeof window !== 'undefined' && window.name === ZERNIO_CONNECT_WINDOW
);

export { ZERNIO_CONNECT_WINDOW, isZernioConnectWindow };
